import Big from "big.js";

const maxCircularValue = 100;

const getCountdownTimerProps = ({
  timeToEnd,
  checkoutDurationSeconds,
}: {
  timeToEnd: number;
  checkoutDurationSeconds: number;
}) => {
  const minutes = Big(timeToEnd)
    .div(60)
    .mod(60)
    .round(0, Big.roundDown)
    .toString()
    .padStart(2, "0");

  const seconds = Big(timeToEnd).mod(60).round().toString().padStart(2, "0");

  const text = `${minutes}:${seconds}`;

  const countdownValue = Big(timeToEnd)
    .div(checkoutDurationSeconds)
    .times(maxCircularValue)
    .toNumber();

  return { text, countdownValue };
};

export default getCountdownTimerProps;
